export function beforeSave(uoms) {
  return uoms.filter((uom) => uom.uom && uom.conversion);
}
